<template>
  <div id="login">
    <div class="row h-100 justify-content-center align-items-center">
      <form class="login-form forgot-password-form form" @submit.prevent="onForgotPasswordPress">
        <h3 class="text-center brand">
          <img src="/frontend/img/logo-icon.svg" />
        </h3>
        <div class="form-group">
          <input
            type="text"
            v-model="login"
            name="login"
            id="login"
            class="form-control"
            :class="{ 'has-error': errors.login }"
            :placeholder="i18n.app.components.login.email_or_username"
          />
          <div class="error" v-if="errors.login">
            <div v-for="(message, index) in errors.login" :key="index">{{ message }}</div>
          </div>
        </div>
        <div class="form-group text-center">
          <button
            :disabled="state.loading"
            @click.prevent="onForgotPasswordPress"
            class="btn btn-default"
            :class="state.loading && 'load-spinner'"
          >
            <span>{{ i18n.app.components.login.send_reset_link }}</span>
          </button>
        </div>
        <div class="text-center footer-brand">
          <img src="/frontend/img/logo-grey.svg" />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import dialogMixin from "@/mixins/dialog.mixin";

export default {
  data() {
    return {
      state: {
        loading: false
      },
      login: "",
      errors: {}
    };
  },
  mixins: [dialogMixin],
  methods: {
    onForgotPasswordPress() {
      this.state.loading = true;
      this.errors = {};

      this._forgotPassword({ login: this.login })
        .then(() => {
          this.showSimpleMessage(i18n.app.login.messages.reset_link_sent);
        })
        .catch(response => {
          // An address or username we do not know comes back per field, in the
          // user's language. It used to be logged to the console and nowhere else.
          this.errors = response?.data?.errors ?? {};

          if (!Object.keys(this.errors).length) {
            this.errors = { login: [this.i18n.messages.something_went_wrong] };
          }
        })
        .finally(() => (this.state.loading = false));
    },
    ...mapActions({
      _forgotPassword: "forgotPassword",
    })
  }
};
</script>
